import { render, staticRenderFns } from "./start-your-journey-for-free.vue?vue&type=template&id=acc46ce0&scoped=true&"
import script from "./start-your-journey-for-free.vue?vue&type=script&lang=js&"
export * from "./start-your-journey-for-free.vue?vue&type=script&lang=js&"
import style0 from "./start-your-journey-for-free.vue?vue&type=style&index=0&id=acc46ce0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc46ce0",
  null
  
)

export default component.exports